import { FunctionComponent, useEffect } from 'react';
import Footer from '../../shared/footer/footer';
import TopMenu from '../../shared/top-menu/top-menu';
import './home-landingpage.scss';
import HomeTopBanner from '../../home/home-top-banner';
import BuyNowButton from '../../shared/buy-now-button/buy-now-button';
import LogoCarousel from '../../home/logo-carousel';
import FeaturesOverview from '../../features/features-overview';
import {
  featuredVideosDE,
  featuredVideosEN,
  featuredVideosLandingPageDE,
} from '../../education/all-videos';
import EducationUnit from '../../education/education-unit';
import Persona from '../../home/persona/persona';
import H2 from '../../shared/html-tags/h2';
import P from '../../shared/html-tags/p';
import A from '../../shared/html-tags/a';
import H3 from '../../shared/html-tags/h3';
import DIV from '../../shared/html-tags/div';

import { Box } from '@mui/material';
import HomeLandingPageTopBanner from './home-landingpage-top-banner';
import { Helmet } from 'react-helmet-async';

export type Props = {};

//To Do: <head>    <link rel="canonical" href="https://predictivesolutions.2x4.de/de/home">    </head>

const HomeLandingPage: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------

  return (
    <>
      <Helmet>
        <title>Kaufe SPSS PLUS: IBM SPSS Statistics & PS IMAGO PRO</title>
        <meta
          name="description"
          content="Kauf von SPSS, aber geboostet: Schnelle & günstige statistische Datenanalyse mit IBM SPSS Statistics & PS IMAGO PRO. Kauflizenzen & Subscriptions."
        />
        <meta
          name="keywords"
          content="SPSS, Datenanalyse, PS IMAGO PRO, Statistik, Predictive Solutions, Auswertung"
        />
        <link rel="canonical" href="https://predictivesolutions.2x4.de/de/home" />
      </Helmet>

      <div className="page home">
        <TopMenu selected={undefined}></TopMenu>
        <HomeLandingPageTopBanner />

        <div className="page-content bg-1">
          <Box className="inner-content">
            <Box className="home-card">
              <div>
                <P language="de">
                  SPSS PLUS und PS IMAGO PRO bieten dir eine flexible, leistungsstarke und
                  zukunftssichere Lösung für datenbasierte Entscheidungen. Du erhältst nicht nur IBM
                  SPSS Statistics in der passenden Lizenzform (z. B. Kauflizenzen, Mietlizenzen,
                  Subscriptions, Dauerlizenzen oder Netzwerklizenzen), sondern auch eine
                  professionelle Erweiterung für automatisierte Berichte, interaktive Dashboards und
                  maximale Effizienz.
                </P>
                <H2 language="de">
                  Warum SPSS PLUS – Editionen, Lizenzierung und Kosten im Überblick
                </H2>
                <DIV language="de">
                  <ul>
                    <li>
                      Flexibel wählbare Lizenzmodelle: Kauflizenz, Mietlizenz, Subscription oder
                      Netzwerklizenz
                    </li>
                    <li>
                      Zugriff auf alle Editionen: SPSS Statistics Base, Plus und SPSS Statistics
                      Premium
                    </li>
                    <li>
                      Erweiterte Funktionen durch einzelne Module wie AMOS, Custom Tables, Decision
                      Trees
                    </li>
                    <li>
                      Technischer Support, regelmäßige Updates und optionale Renewals inklusive
                    </li>
                    <li>Nutzung auf zwei Geräten pro Lizenz möglich</li>
                    <li>
                      Transparent kalkulierbare Kosten – ideal für Einzelpersonen, Teams und
                      Organisationen jeder Größe
                    </li>
                    <li>Auch als Statistics Premium Campus Edition für Hochschulen verfügbar</li>
                    <li>
                      PS IMAGO PRO basiert auf echten Nutzeranforderungen und erweitert IBM SPSS
                      Statistics um zentrale Funktionen für deine tägliche Analysearbeit – von der
                      Datenaufbereitung bis zur Ergebnisverteilung
                    </li>
                  </ul>
                </DIV>
              </div>
            </Box>
            <div style={{ textAlign: 'center', margin: '3rem 0' }}>
              <BuyNowButton order={'buy->test'} />
            </div>
          </Box>

          <LogoCarousel />
        </div>

        {/* = Feature Section ========================================================= */}
        <div className="page-content bg-2">
          <div className="inner-content">
            <H2 language="de">Was PS IMAGO PRO in Kombination mit IBM SPSS Statistics bietet</H2>

            <FeaturesOverview />
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <A language="de" href="/features" className="show-all-features-button">
                Alle Features ansehen
              </A>
            </div>
          </div>
        </div>

        <div className="page-content bg-1">
          <div className="inner-content">
            {/* = Preise Section ============================================================== */}
            <H2 language="de">
              In 4 Schritten zur datenbasierten Entscheidung – mit der richtigen SPSS Lizenz &
              optimalen Kosten
            </H2>
            <H3 language="de">1. Die passende SPSS Lizenzform wählen</H3>
            <P language="de">
              Wähle zwischen Kauflizenz, Mietlizenz, Netzwerklizenz oder Subscription – für
              Einzelplatz, Team oder Organisation.
            </P>
            <H3 language="de">2. Einzelne Module & Editionen flexibel kombinieren</H3>
            <P language="de">
              Ergänze dein SPSS-Paket um genau die Funktionen, die du brauchst – von AMOS über
              Forecasting bis zur Visualisierung.
            </P>
            <H3 language="de">3. Analyseprozesse automatisieren</H3>
            <P language="de">
              Einmal konfigurieren, regelmäßig automatisch erstellen – das spart Zeit, Kosten und
              reduziert Fehler.
            </P>
            <H3 language="de">4. Ergebnisse verständlich kommunizieren</H3>
            <P language="de">
              Teile deine Analysen über Dashboards oder Berichte – intern, extern oder öffentlich.
            </P>

            <div
              style={{
                textAlign: 'center',
                margin: '2rem 0 5rem 0',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
            >
              <BuyNowButton order={'test->buy'} />
            </div>

            {/* = Personas Section ============================================================== */}
            <H2 language="de">
              Branchenlösungen mit IBM SPSS Statistics, PS IMAGO PRO & Einzelmodulen
            </H2>
            <div className="persona-section">
              <Persona
                area={'Business Intelligence'}
                slogan={
                  '„Erkenne Trends frühzeitig, optimiere KPIs und reagiere schnell auf Veränderungen.“'
                }
                description={() => (
                  <>
                    Dank PS IMAGO PRO habe ich alle KPIs im Blick und reagiere blitzschnell auf
                    Veränderungen. Die automatisierte Berichterstellung spart Zeit und erleichtert
                    strategische Entscheidungen. Ob Marktanalysen oder Umsatzprognosen – unser
                    Unternehmen ist auf Erfolgskurs!
                  </>
                )}
                showcaseurl="/de/showcases/businessintelligence"
              />

              <Persona
                area={'Marktforschung'}
                slogan={
                  '„Analysiere Kundenbedürfnisse und Umfrageergebnisse effizient – auch mit komplexen Stichproben.“'
                }
                description={() => (
                  <>
                    Mit PS IMAGO PRO analysiere ich im Handumdrehen Umfragedaten und entdecke
                    Trends, bevor sie entstehen. So biete ich maßgeschneiderte Empfehlungen, die
                    sicherstellen, dass Produkte nicht nur gesehen, sondern geliebt werden.
                  </>
                )}
                showcaseurl="/de/showcases/marketresearch"
              />

              <Persona
                area="Gesundheitswesen"
                slogan="„Verarbeite medizinische Daten sicher und nutze präzise Berichte für Forschung und Versorgung.“"
                description={() => (
                  <>
                    In der klinischen Forschung sind Präzision und Verlässlichkeit entscheidend. Mit
                    aktuellen Informationen, direkt in der Cloud abrufbar, kann ich komplexe
                    medizinische Daten analysieren und klare Berichte erstellen. Die Gesundheit
                    unserer Patienten hat Priorität, mit dieser Software bleiben wir dem
                    Krankheitsverlauf stets einen Schritt voraus!
                  </>
                )}
                showcaseurl="/de/showcases/healthcare"
              />

              <Persona
                area="Politik"
                slogan="„Politische Entscheidungen mit Durchblick!“"
                description={() => (
                  <>
                    PS IMAGO PRO hilft mir dabei, statistische Analysen verständlich aufzubereiten,
                    sodass unsere Strategien evidenzbasiert und zukunftssicher sind. Ob
                    Bevölkerungsdaten oder Umfragen zur öffentlichen Meinung – mit dieser Lösung
                    treffe ich fundierte Entscheidungen für die Gesellschaft.
                  </>
                )}
                showcaseurl="/de/showcases/politics"
              />

              <Persona
                area="Finanzwesen"
                slogan="„Führe Risikoanalysen durch, erstelle Marktprognosen und unterstütze Investitionsentscheidungen.“"
                description={() => (
                  <>
                    PS IMAGO PRO gibt mir die Werkzeuge an die Hand, um Risikoanalysen effizient
                    durchzuführen und präzise Marktprognosen zu erstellen. Echtzeit-Dashboards
                    helfen, Chancen frühzeitig zu erkennen und kluge Investitionsentscheidungen zu
                    treffen.
                  </>
                )}
                showcaseurl="/de/showcases/finance"
              />

              <Persona
                area="Produkt & Qualitätsmanagement"
                slogan="„Überwache Produktqualität, finde Schwachstellen frühzeitig und steigere Effizienz.“"
                description={() => (
                  <>
                    PS IMAGO PRO bietet mir umfassende Einsicht in Qualitätsdaten, sodass ich
                    Optimierungspotenziale sofort identifizieren kann. Ob in der Entwicklungsphase
                    oder beim Markteintritt – die Software ermöglicht, dass jedes Produkt den
                    höchsten Standards entspricht und ein Erfolg wird.
                  </>
                )}
                showcaseurl="/de/showcases/productquality"
              />
              <Persona
                area="Bildung"
                slogan="„Verbessere Lehre und Organisation durch gezielte Analysen von Leistungs- und Ressourcenkennzahlen.“"
                description={() => (
                  <>
                    Mit PS IMAGO PRO analysiere ich Leistungsdaten und Bildungsstatistiken, um
                    fundierte Entscheidungen für eine optimierte Lehre zu treffen. Von Schüler- und
                    Studierendenerfolgen bis hin zur Ressourcenplanung – diese Lösung hilft
                    Bildungseinrichtungen, ihre Qualität datenbasiert zu verbessern.
                  </>
                )}
                showcaseurl="/de/showcases/education"
              />
              <Persona
                area="Kommunale Verwaltung"
                slogan="„Optimiere Prozesse, bewerte Bürgeranliegen und sorge für transparente Entscheidungsgrundlagen.“"
                description={() => (
                  <>
                    Mit PS IMAGO PRO optimiere ich Verwaltungsprozesse, indem ich Daten zu
                    Bürgeranliegen, Ressourcenplanung und Infrastrukturanalysen effizient auswerte.
                    Ob bei der Verbesserung öffentlicher Dienstleistungen oder der transparenten
                    Berichterstattung – diese Lösung unterstützt kommunale Verwaltungen bei
                    fundierten Entscheidungen für die Gesellschaft.
                  </>
                )}
                showcaseurl="/de/showcases/municipaladministration"
              />
            </div>
          </div>
        </div>

        <div className="page-content bg-2">
          <div className="inner-content">
            {/* = Learning Section ============================================================== */}
            <H2 language="de">
              Tutorials & Einstieg – SPSS Statistics, AMOS & einzelne Module einfach erklärt
            </H2>
            <DIV language="de">
              <p>Wie helfen dir unsere SPSS Tutorials?</p>
              <p>
                Du lernst Schritt für Schritt, wie du aus Daten greifbare Erkenntnisse machst –
                visuell, interaktiv und automatisiert:
              </p>
              <br />
              <div className="education-units">
                {featuredVideosLandingPageDE.map((video, i) => (
                  <EducationUnit
                    key={i}
                    numVideo={video.videoNumber ?? i + 1}
                    name={video.title}
                    description={video.description}
                    duration={video.lengthInSeconds}
                    videolink={video.link}
                    preview={''}
                  />
                ))}
              </div>
              <div className="all-learnings">
                <a href="/de/education" className="link">
                  Mehr entdecken
                </a>
              </div>
              <div style={{ marginTop: '2rem' }}>
                Zusätzlich bieten wir dir Schulungen, Webinare und fertige Berichtsvorlagen.
              </div>
            </DIV>
            <DIV language="en">
              There is a wealth of tutorials and courses available for this software. Here are our
              recommendations for you.
              <br />
              <div className="education-units">
                {featuredVideosEN.map((video, i) => (
                  <EducationUnit
                    key={i}
                    numVideo={video.videoNumber ?? i + 1}
                    name={video.title}
                    description={video.description}
                    duration={video.lengthInSeconds}
                    videolink={video.link}
                    preview={''}
                  />
                ))}
              </div>
              <div className="all-learnings">
                <a href="/en/education" className="link">
                  Find more
                </a>
              </div>
            </DIV>
          </div>
        </div>
        <div className="page-content bg-1">
          <div className="inner-content">
            {/* = Learning Section ============================================================== */}
            <H2 language="de">Häufige Fragen zu SPSS Lizenzierung, Updates, Renewals & mehr</H2>
            <DIV language="de">
              <b>Ist PS IMAGO PRO mit meiner SPSS-Version kompatibel?</b>
              <br />
              Ja, PS IMAGO PRO beinhaltet das originale SPSS und ist mit verschiedenen Versionen
              verfügbar, inkl. Version 29 und höher.
            </DIV>

            <DIV language="de">
              <b>Kann ich das System vor dem Kauf testen?</b>
              <br />
              Ja, du kannst SPSS PLUS inklusive PS IMAGO PRO kostenlos testen – ohne Verpflichtung.
            </DIV>

            <DIV language="de">
              <b>Was ist bei Updates & Renewals enthalten?</b>
              <br />
              Du erhältst 12 Monate technischen Support, regelmäßige Updates und auf Wunsch eine
              unkomplizierte Verlängerung deiner Lizenz (Renewal).
            </DIV>

            <H2 language="de">Deine Vorteile mit SPSS PLUS, Amos & Einzelmodulen im Überblick</H2>
            <ul>
              <li>Erweiterte Funktionen für IBM SPSS Statistics</li>
              <li>Kompatibel mit allen wichtigen SPSS-Modulen</li>
              <li>Flexible Lizenzmodelle (Kauf, Miete, Subscription)</li>
              <li>Plattformübergreifend nutzbar: Windows, macOS, Linux</li>
              <li>Automatisierte Analysen und Berichte sparen Zeit und Geld</li>
              <li>Volle Kontrolle über Verteilung, Layout und Veröffentlichung</li>
              <li>Entwicklung basierend auf echtem Kundenfeedback aus über 30 Ländern</li>
            </ul>
          </div>
        </div>
        <Footer></Footer>
      </div>
    </>
  );
};

export default HomeLandingPage;
